import React, { memo } from 'react';
import classnames from 'classnames';
import { createUseStyles, Text } from '@Sage/hoi-poi-ui';

import styles from './styles.js';
const useStyles = createUseStyles(styles, 'PasswordPolicies');

const PasswordPolicies = ({ password, policies = [], t, className }) => {
    const classes = useStyles();

    return (
        <div className={classnames(classes.root, className)}>
            {policies.map((policy, idx) => {
                const accepted = policy.condition(password);
                return (
                    <Text
                        key={idx}
                        type="caption"
                        className={classnames(classes.policy, {
                            [classes.on]: accepted,
                            [classes.off]: !accepted,
                        })}
                    >
                        {t(policy.literal, [policy.number])}
                    </Text>
                );
            })}
        </div>
    );
};

export default memo(PasswordPolicies);
